import { Modal, Form, Input, Select, Button } from 'antd';
import { t } from '@/utils/translator';
import LanguageSwitcher from '@common/LanguageSwitcher';
import { COUNTRIES, CLIENT_CORPORATES } from '@/constants/siteData';
import i18n from '@/i18n';

const { Option } = Select;

const SiteEditModal = ({ isVisible, isEdit, form, onSave, onCancel, onClose, onReset, requiredForm = { site_name: true, site_country: true, site_location: true, site_clients: true } }) => {
  return (
    <Modal
      title={isEdit ? t('사업장 정보 수정') : t('사업장 추가')}
      open={isVisible}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <div key="footer" className="d-flex justify-content-between">
          <LanguageSwitcher />
          <div className="text-right">
            <Button type="danger" onClick={onReset}>
              {t('취소')}
            </Button>
            <Button
              className="bg-gray-3 text-gray-1 hover-bg-gray-2 hover-border-gray-2 hover-text-gray-1"
              onClick={onCancel}
            >
              {t('닫기')}
            </Button>
            <Button type="primary" onClick={onSave}>
              {t('저장')}
            </Button>
          </div>
        </div>,
      ]}
      centered
    >
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 15 }}
        initialValues={{ remember: true }}
        autoComplete="off"
        className="py-2"
        labelAlign="left"
        labelWrap
      >
        <Form.Item
          label={t('사업장 이름')}
          name="site_name"
          className="mb-3"
          rules={[{ required: requiredForm.site_name, message: t('사업장 이름을 입력해주세요') }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={t('사업장 국가')}
          name="site_country"
          className="mb-3"
          rules={[{ required: requiredForm.site_country, message: t('사업장 국가를 선택해주세요') }]}
        >
          <Select placeholder={t('선택')}>
            {COUNTRIES.map((item, _item_idx) => (
              <Option key={`countries-${_item_idx}-${item}`} value={item}>
                {item}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={t('사업장 주소')}
          name="site_location"
          className="mb-3"
          rules={[{ required: requiredForm.site_location, message: t('사업장 주소를 입력해주세요') }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="site_clients"
          label={t('납품중인 만도 법인')}
          className="mb-0"
          rules={[{ required: requiredForm.site_clients, message: t('납품중인 만도 법인을 선택해주세요') }]}
        >
          <Select
            mode="multiple"
            options={CLIENT_CORPORATES}
            style={{ width: '100%' }}
            fieldNames={{
              label: `corporate_name_${i18n.language}`,
              value: `corporate_name_${i18n.language}`,
            }}
            placeholder={t('납품중인 만도 법인은 선택해주세요')}
            allowClear
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SiteEditModal;
